import React, { Component } from 'react';

import Header from "../Header/Header"
import Footer from "../Footer/Footer"
import BackToSchool from '../Screens/0_BackToSchool/BackToSchool'; //0
import Sandwich from '../Screens/1_Sandwich/Sandwich'; //1
import Springroll from '../Screens/2_Springroll/Springroll'; //2
import Kassadia from '../Screens/3_Kassadia/Kassadia'; //3
import Kosmin from '../Screens/4_Kosmin/Kosmin'; //4
import Omlet from '../Screens/5_Omlet/Omlet'; //5
import Pita from '../Screens/6_Pita/Pita'; //6
import VideosBottom from '../Screens/7_VideosBottom/VideosBottom'; //7
import Landscape from '../Landscape/Landscape';
import { wheelDragDirection } from "../Services/SwipeEvents";

import queryString from 'query-string'
import ScrollableAnchor from 'react-scrollable-anchor'
import { GA_Push, GA_VPush } from '../Services/GoogleAnalytics';

const sections = ["backtoschool", "sandwich", "springroll", "kassadia", "kosmin", "omlet", "pita", "videosbottom"];

const circles = ['עמוד בית', 'כריך ים תיכוני', "כריך ספרינג רול", "קאסדייה", "כריך לחם כוסמין", "כריך חביתה מיוחדת", "כריך פיצה חם", "קופצים כיתה עם נֹעם"];

export default class App extends Component {
  constructor(props) {
    super(props)
    this.setTransform = this.setTransform.bind(this);
    this.state = {
      isBusy: false,
      currentScreen: 0,
      transform: 0
    }
  }

  componentDidMount() {
    const parse = window.location.search ? queryString.parse(window.location.search) : "";

    this.mainScreen.addEventListener('swu', (event) => this.wrapperScrolling(event));
    this.mainScreen.addEventListener('swd', (event) => this.wrapperScrolling(event));
    this.mainScreen.addEventListener("mousewheel", (event) => this.wrapperScrolling(event));
    this.mainScreen.addEventListener('DOMMouseScroll', (event) => this.wrapperScrolling(event));
    window.setTimeout(() => {
      var _body = window.document.body;
      if (_body.className && _body.className.indexOf("tara-home-screen") < 0) {
        _body.className += " tara-home-screen"
      }
    }, 100)

    if (parse != null && parse.s) {
      for (let i = 0; i < sections.length; i++) {
        if (parse.s == sections[i]) {
          this.setTransform(i);
          continue;
        }
      }
    }

    // try {
    //   this.activeNavigation(!parse.s || !parse ? sections[0] : (!this[parse.s] ? sections[0] : this[parse.s].classList[1]));
    // } catch (e) { }
    // if (parse && parse.s != this.state.currentHash && this[parse.s]) {
    //   window.setTimeout(() => {
    //     var _className = this[parse.s].className.split(" ");
    //     // this.props.setTransform(window.document.querySelector(`.section-${_className[1]}`).offsetTop / window.document.body.clientHeight);
    //   }, 500);
    // }
  }

  // activeNavigation = _className => {
  //   if (!this[_className]) return;
  //   this[_className].className = this[_className].className += " active";
  //   if (typeof (window.history.pushState) == 'function') {
  //     var parse = window.location.search ? queryString.parse(window.location.search) : "";
  //     parse = {
  //       ...parse,
  //       s: _className
  //     }
  //     window.history.pushState(null, `/`, `?${queryString.stringify(parse)}#`);
  //   }
  // }


  setTransform(num) {
    let lastscreen = this.state.currentScreen;
    let screen = "";
    this.setState({
      currentScreen: num,
      transform: `translateY(${-(num * 100)}vh)`
    })

    GA_VPush(circles[num], `/?s=${sections[num]}`);

    if (typeof window.history.pushState == "function") {
      if (window.document.location.search && window.document.location.search.indexOf("s=") > -1) {
        screen = window.document.location.search.replace(sections[lastscreen], sections[num]);
        window.history.pushState(null, `/`, `${screen}`);
      } else{
        window.history.pushState(null, `/`, `${window.document.location.search}${window.document.location.search ? "&" : "?"}${window.document.location.search.indexOf("s=") > -1 ? "" : `s=${sections[num]}`}`);
      }
    }
  }

  wrapperScrolling(event) {
    if (this.state.isBusy) return;
    this.setState({
      isBusy: true
    }, () => {
      window.setTimeout(() => {
        this.setState({
          isBusy: false
        })
      }, 800);
    })

    var num = this.state.currentScreen;
    if (wheelDragDirection(event) == "down") {
      num++;
    } else {
      num--;
    }

    num = num < 0 ? 0 : num;
    num = num >= 7 ? 7 : num;
    this.setTransform(num);
  }

  render() {

    return (
      <div className="App" >
        <Landscape />
        <Header currentScreen={this.state.currentScreen} setTransform={this.setTransform} />
        <main className="main-wrapper" ref={mainScreen => this.mainScreen = mainScreen} style={{ transform: this.state.transform }} >
          <BackToSchool setTransform={this.setTransform} />
          <Sandwich currentScreen={this.state.currentScreen} />

          <Springroll />

          <Kassadia />

          <Kosmin />

          <Omlet />

          <Pita />

          <VideosBottom currentScreen={this.state.currentScreen} />

        </main>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/App/App.jsx